import { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import LandingPage from './pages/LandingPage'
import ProjectIntro from './pages/ProjectIntro'
import LearnAbout from './pages/LearnAbout'
import ContactUs from './pages/ContactUs'
import JoinPage from './pages/JoinPage'

const TaskDashboard = lazy(() => import('./pages/TaskDashboard'));
const AdminPanel = lazy(() => import('./pages/AdminPanel'));

const PageLoader = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        color: 'var(--text-primary, #fff)'
    }}>
        Loading...
    </div>
);

function App() {
    useEffect(() => {
        (window as any).$crisp = [];
        (window as any).CRISP_WEBSITE_ID = "b79e1c20-c92d-485e-8018-314742327d5b";

        if (document.getElementById("crisp-chat-script")) return;

        const script = document.createElement("script");
        script.id = "crisp-chat-script";
        script.src = "https://client.crisp.chat/l.js";
        script.async = true;

        document.head.appendChild(script);
    }, []);

    return (
        <Router>
            <Suspense fallback={<PageLoader />}>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/project-intro" element={<ProjectIntro />} />
                    <Route path="/learn" element={<LearnAbout />} />
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="/join" element={<JoinPage />} />
                    <Route path="/dashboard" element={
                        <ProtectedRoute>
                            <TaskDashboard />
                        </ProtectedRoute>
                    } />
                    <Route path="/secure-admin-portal" element={<AdminPanel />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Suspense>
        </Router>
    )
}

export default App